package com.exura.ui.modifiers

import androidx.compose.runtime.*
import com.exura.ui.*
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.px

@Composable
fun Modifier.insetHoverableItemStyle(
    isSelected: Boolean = false,
    shadeColor: ExuraRgba = ExuraColors.BLACK.copy(alpha = 0.05),
    shadeSize: CSSLengthNumericValue = 8.px,
    shadeBorders: List<ShadeBorder> = listOf(ShadeBorder.TOP, ShadeBorder.LEFT),
    backgroundColor: ExuraRgba = ExuraColors.TRANSPARENT,
    hoverColor: ExuraRgba = backgroundColor,
    selectedColor: ExuraRgba = backgroundColor,
    isHoverable: Boolean = true,
    cursor: Cursor = Cursor.Default,
    onClick: (() -> Unit)? = null,
): Modifier {
    var isHovered by remember { mutableStateOf(false) }

    return this
        .onMouseEnter { if (isHoverable) isHovered = true }
        .onMouseLeave { if (isHoverable) isHovered = false }
        .cursor(if (isHoverable) cursor else Cursor.Default)
        .transition(
            Transition.of(
                property = HtmlProperties.ALL,
                duration = Durations.short,
                timingFunction = AnimationTimingFunction.EaseInOut,
            )
        )
        .backgroundColor(
            when {
                isHovered && isHoverable -> hoverColor
                isSelected -> selectedColor
                else -> backgroundColor
            }
        )
        .boxShadow(
            * when {
                isHovered && isHoverable -> shadeBorders.map { border ->
                    getBorderBoxShadow(
                        border = border,
                        shadeSize = shadeSize,
                        shadeIntensity = 0.8,
                        shadeColor = shadeColor,
                    )
                }.toTypedArray()

                isSelected -> shadeBorders.map { border ->
                    getBorderBoxShadow(
                        border = border,
                        shadeSize = shadeSize,
                        shadeIntensity = 0.6,
                        shadeColor = shadeColor,
                    )
                }.toTypedArray()

                else -> arrayOf(BoxShadow.of())
            }

        )
        .let { modifier ->
            if (onClick != null) {
                modifier.onClick { event ->
                    event.stopPropagation()
                    onClick()
                }
            } else {
                modifier
            }
        }
}
